import './App.css';
import { BrowserRouter as Router } from "react-router-dom";
import RouteContainer from "./RouteContainer";
import ToastContainer from "./components/ajonjolib/toasts/toast/toast_container";
import { SidebarProvider } from "./contexts/SidebarContext";

function App() {
  return (
      <div className="App">
          <SidebarProvider>
              <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                  <RouteContainer/>
              </Router>
          </SidebarProvider>
          <ToastContainer/>
      </div>
  );
}

export default App;
